export const NO_OF_STARS = 5;
export const STAR_COLOR = "#f9db36";
export const STAR_DIMENSION = "14px";
export const STAR_SPACING = "2px";
